import type { Maybe } from '@shared/utils/src/types';
import type { CartAddress } from '../../../codegen/types';

export interface FormatAddress {
  country: Maybe<string> | undefined;
  city: Maybe<string> | undefined;
  houseNumberOrName: string;
  postalCode: Maybe<string> | undefined;
  street: Maybe<string> | undefined;
  stateOrProvince: Maybe<string> | undefined;
}

export const formatAddress = (address?: CartAddress | null): FormatAddress | null =>
  address
    ? {
        country: address?.country,
        city: address?.city,
        houseNumberOrName: address?.line2 ?? '',
        postalCode: address?.postalCode,
        street: address?.line1,
        stateOrProvince: address?.state,
      }
    : null;
